import { Pagination as PaginationComponent } from '../../../shared/NarusMaterial'

import styles from './index.module.css'
import { PageSizeSelector } from './page-size-selector'

interface Props {
  total?: number
  page: number
  pageSize: number
  extra?: React.ReactNode
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export function Pagination ({
  total = 0,
  page,
  pageSize,
  extra,
  onPageChange,
  onPageSizeChange
}: Props): JSX.Element | null {
  let totalPages = Math.ceil(total / pageSize)

  let firstItem = page * pageSize + 1
  let lastItem = Math.min(total, firstItem + pageSize - 1)

  let message = total === 0
    ? 'No results'
    : `${firstItem}–${lastItem} of ${total}`

  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className={styles.information}>
          <p className={styles.result}>
            {message}
          </p>
          <PageSizeSelector
            pageSize={pageSize}
            onPageSizeChange={onPageSizeChange}
          />
        </div>

        {extra}
      </div>
      {total !== 0 && (
        <div className={styles.paginationSection}>
          <PaginationComponent
            totalPages={totalPages}
            currentPage={page + 1}
            onChange={onPageChange}
          />
        </div>
      )}

    </div>
  )
}
